<script lang="ts">
	import Message from '$lib/components/messages/Message.svelte';

	interface Props {
		message: string;
		url: string;
		label: string;
	}

	const { message, url, label }: Props = $props();
</script>

<Message {message} {url} {label} class="bg-neutral-weakest border-neutral-soft" />
